<template lang='pug'>
  v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon brush
            h4.title
              | {{ $t("webChannel.fcr.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              .md-layout
                .md-layout
                  .md-layout-item(style='margin: auto;padding-left:0;')
                    | {{
                    | $t(
                    | "webChannel.fcr.subitems.enable"
                    | )
                    | }}
                  .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                  'text-success': canalWebData.isFCRActive,\
                  'text-danger': !canalWebData.isFCRActive\
                  }")
                    | {{
                    | canalWebData.isFCRActive
                    | ? $t("commonWords.enabled")
                    | : $t("commonWords.disabled")
                    | }}
                  .md-layout-item.md-size-15
                    md-switch(v-model='canalWebData.isFCRActive')
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.fcr.subitems.message"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.messageRatingFCR' md-autogrow)
                md-field
                  label
                    | 1º -
                    | {{
                    | $t(
                    | "webChannel.fcr.subitems.option"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.messageOptionFCR1' md-autogrow)
                md-field
                  label
                    | 2º -
                    | {{
                    | $t(
                    | "webChannel.fcr.subitems.option"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.messageOptionFCR2' md-autogrow)
                md-field
                  label
                    | 3º -
                    | {{
                    | $t(
                    | "webChannel.fcr.subitems.option"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.messageOptionFCR3' md-autogrow)
</template>

<script>
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  computed: {
    conversationQuantityFields: {
      get: function () {
        return this.canalWebData.conversationRatingLabels.length
      },
      set: function (nV) {
        this.canalWebData.conversationRatingLabels = this.labels.slice(0, nV)
      }
    }
  },
  data () {
    return {
      labels: ['☆', '☆☆', '☆☆☆', '☆☆☆☆', '☆☆☆☆☆']
    }
  }
}
</script>
